import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { Status } from 'generated/graphql';
import { useState } from 'react';
import { DashboardHeaderAddAnalysisButton } from '../DashboardHeaderActions/DashboardHeaderAddAnalysisButton';
import { EmptyDashboardBarIllustration } from './EmptyDashboardBarIllustration';
import { EmptyDashboardPieIllustration } from './EmptyDashboardPieIllustration';

const EXPANDED_ILLUSTRATION_POSITIONS = {
  pieTop: -18,
  pieLeft: -8,
  barTop: 15,
  barLeft: 32,
};

export const EmptyDashboard = () => {
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);
  const hasEditToken = dashboard?.editToken;
  const isArchived = dashboard?.status === Status.Archived;

  const [isAddButtonHovered, setIsAddButtonHovered] = useState(false);

  const EmptyDashboardMessage = () => {
    if (isArchived) {
      return <>This Dashboard is Archived</>;
    }
    if (hasEditToken || !dashboard.id) {
      return (
        <Box component="span">
          Ready, set, analyze! Let's unveil hidden gems.
          <br />
          Add a Quantify to the Dashboard and let the feedback magic begin! ✨
        </Box>
      );
    }
    return <>Request access to add Quantify to this Dashboard.</>;
  };

  const getIllustrationPosition = (basePosition: number, hoverOffset: number) =>
    basePosition + (isAddButtonHovered ? hoverOffset : 0);

  return (
    <Grid container height="70vh">
      <Grid item xs={2} />
      <Grid item xs={8}>
        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={4}
          height="100%"
        >
          <Stack>
            <Box
              position="relative"
              top={getIllustrationPosition(
                90,
                EXPANDED_ILLUSTRATION_POSITIONS.pieTop,
              )}
              left={getIllustrationPosition(
                0,
                EXPANDED_ILLUSTRATION_POSITIONS.pieLeft,
              )}
              sx={{ transition: '0.5s ease-in-out' }}
            >
              <EmptyDashboardPieIllustration isColored={isAddButtonHovered} />
            </Box>
            <Box
              position="relative"
              left={getIllustrationPosition(
                45,
                EXPANDED_ILLUSTRATION_POSITIONS.barLeft,
              )}
              top={getIllustrationPosition(
                0,
                EXPANDED_ILLUSTRATION_POSITIONS.barTop,
              )}
              sx={{ transition: '0.5s ease-in-out' }}
            >
              <EmptyDashboardBarIllustration isColored={isAddButtonHovered} />
            </Box>
          </Stack>
          <Box marginTop={4}>
            <Typography variant="h6" color="text.disabled" align="center">
              <EmptyDashboardMessage />
            </Typography>
          </Box>
          <DashboardHeaderAddAnalysisButton
            setIsHovered={setIsAddButtonHovered}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};
